import React, { FC } from 'react'

export type DebugProps = any

export const Debug: FC<DebugProps> = (props) => {
  if (process.env.NODE_ENV === 'production') {
    return null
  }

  return (
    <div
      style={{
        border: '1px solid red',
        padding: 5,
        color: 'red',
        fontSize: '12px',
      }}
    >
      <code>{JSON.stringify(props, null, 2)}</code>
    </div>
  )
}
